import { Card, CardMemo, Post, Profile, Subject } from "../types";

export const MOCK_USER: Profile = {
  id: "user-1",
  display_name: "学問 太郎",
  grade: "高校1年",
  affiliation: "1年A組",
  bio: "日常の中で新しい発見をするのが好きです。",
  role: "student",
  avatar_url: "https://i.pravatar.cc/150?u=user-1",
};

export const SUBJECTS: Subject[] = [];

export const MOCK_CARDS: Card[] = [];

export const MOCK_POSTS: Post[] = [
  {
    id: "post-1",
    user_id: "user-1",
    body: "今日見つけたもの：マクドナルドの看板\n使ったレンズ：配色\nそう考えた理由：赤と黄色が使われていて、遠くからでもすごく目立っていたから。\n新しく気づいたこと：赤は食欲をそそる色で、黄色は注意を引く色らしい。ファストフード店によくある組み合わせ。\n次に調べたいこと：他の飲食店の看板の色使い",
    reflection: "日常の風景も色に注目すると面白い。",
    discovery_type: "日常の発見",
    visibility: "class",
    created_at: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
    card_ids: ["card-33"],
  },
  {
    id: "post-2",
    user_id: "user-1",
    body: "スーパーでトイレットペーパーを買う時、12ロール入りと18ロール入りでどっちがお得か計算した。",
    reflection: "単価を出すことで比較しやすくなった。",
    discovery_type: "買い物の工夫",
    visibility: "public",
    created_at: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
    card_ids: ["card-6"],
  },
];

export const MOCK_CARD_MEMOS: CardMemo[] = [
  {
    id: "memo-1",
    card_id: "card-33",
    user_id: "user-1",
    content:
      "スターバックスのロゴは緑色。なぜ緑？自然、リラックス、プレミアムなイメージかな。",
    media_urls: ["https://via.placeholder.com/150x150?text=starbucks"],
    links: ["https://example.com/colors"],
    created_at: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(),
    updated_at: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(),
  },
];
